import { ExcelErrorCode, ExcelReadError } from '@/lib/xlsx'

export function isExcelFile(file: File): boolean {
  return (
    file.type ===
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
    file.type === 'application/vnd.ms-excel' ||
    file.name.endsWith('.xls') ||
    file.name.endsWith('.xlsx')
  )
}

export function formatFileSize(sizeInBytes: number): string {
  return (sizeInBytes / 1024).toFixed(2)
}

export function getExcelValidationErrorKey(
  error: ExcelErrorCode
):
  | 'toolManagement.invalidFileType'
  | 'toolManagement.fileSizeTooLarge'
  | 'toolManagement.invalidFile' {
  if (error === ExcelErrorCode.INVALID_FILE_TYPE) {
    return 'toolManagement.invalidFileType'
  }
  if (error === ExcelErrorCode.FILE_SIZE_TOO_LARGE) {
    return 'toolManagement.fileSizeTooLarge'
  }
  return 'toolManagement.invalidFile'
}

export function getExcelReadErrorKey(error: unknown): string {
  if (error instanceof ExcelReadError) {
    if (error.code === ExcelErrorCode.EXCEL_READ_ERROR) {
      return 'toolManagement.excelReadError'
    }
    if (error.code === ExcelErrorCode.FILE_READING_FAILED) {
      return 'toolManagement.fileReadingFailed'
    }
    return 'toolManagement.fileProcessingError'
  }
  return 'toolManagement.fileProcessingError'
}
